// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../gaswerk/assets/Figtree[wght].woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../gaswerk/assets/Figtree-Italic[wght].woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Figtree';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2-variations');
  font-weight: 300 900;
}

@font-face {
  font-family: 'Figtree';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2-variations');
  font-weight: 300 900;
  font-style: italic;
}

.poster-layout-container {
  font-family: 'Figtree', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./functions/poster-layout/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uEAA4E;EAC5E,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uEAAmF;EACnF,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["@font-face {\n  font-family: 'Figtree';\n  src: url('../gaswerk/assets/Figtree[wght].woff2') format('woff2-variations');\n  font-weight: 300 900;\n}\n\n@font-face {\n  font-family: 'Figtree';\n  src: url('../gaswerk/assets/Figtree-Italic[wght].woff2') format('woff2-variations');\n  font-weight: 300 900;\n  font-style: italic;\n}\n\n.poster-layout-container {\n  font-family: 'Figtree', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
